import { render, staticRenderFns } from "./SieMeta.vue?vue&type=template&id=3f2660ad&scoped=true&"
import script from "./SieMeta.vue?vue&type=script&lang=ts&"
export * from "./SieMeta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2660ad",
  null
  
)

export default component.exports